import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { assetsReportsNav4HomeEntryPoint } from '@jira/spa-apps__servicedesk-cmdb-assets-reports/src/assetsReportsNav4HomeEntryPoint.entrypoint.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServicedeskPageContextResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { assetsReportsRoute } from '@jira/router-routes__assets-app-routes/src/assetsReportsRoute.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { toPackageName, APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import type { Route } from '@atlassian/react-resource-router';

const assetsReportsPageEntryPoint = createChromelessEntryPoint({
	main: assetsReportsNav4HomeEntryPoint,
});

export const assetsReportsRouteEntry: Route = createEntry(assetsReportsRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: AssetsSpinner,
	entryPoint: () => assetsReportsPageEntryPoint,
	pageId: () => 'spa-apps/servicedesk/insight/cmdb-assets-reports-home-page',
	resources: [...getAssetsAppResources(), ...getServicedeskPageContextResources()],
	forPaint: [LazyAssetsLayout],
	meta: {
		reporting: {
			id: APP_NAMES.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
			packageName: toPackageName(APP_NAMES.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
			teamName: 'ITSM SAGA',
		},
	},
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
